import React, { FC } from 'react';
import { Colors } from '../../../../styles/colors';

interface Props {
  color: string;
}

export const ProductIconTranchenmodellStrom: FC<Props> = ({ color = Colors.white }) => {
  return (
    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 114.9 117.6" style={{ color }} xmlSpace="preserve" fill="currentColor">
    <path d="M58.6,117.6h-4.7v-12.3h4.7L58.6,117.6z M75.8,117.5L75.8,117.5c-0.7,0-1.4-0.3-1.8-0.8L37.3,72.6c-0.8-1-0.7-2.5,0.3-3.3
      c0.4-0.4,1-0.6,1.5-0.6h14.8V51.5c0-1.3,1.1-2.3,2.3-2.3h14.6L39.1,11L7.4,49.1H22c1.3,0,2.4,1.1,2.4,2.3v49h-4.8V53.8H2.3
      C1,53.8,0,52.7,0,51.4c0-0.5,0.2-1.1,0.5-1.5L37.3,5.8C37.7,5.3,38.4,5,39.1,5l0,0c0.7,0,1.4,0.3,1.8,0.8l36.7,44.1
      c0.8,1,0.7,2.5-0.3,3.3c-0.4,0.3-0.9,0.5-1.5,0.5H58.6v17.3c0,1.3-1.1,2.3-2.3,2.3H44.1l31.7,38.1l31.7-38.1H93
      c-1.3,0-2.3-1.1-2.3-2.3V17.1h4.7v51.5h17.2c1.3,0,2.3,1,2.4,2.3c0,0.6-0.2,1.1-0.6,1.5l-36.8,44.1
      C77.2,117.2,76.5,117.5,75.8,117.5z M36.5,112.7h-4.7V85.8h4.7V112.7z M83.1,31.9h-4.7V0h4.7V31.9z M61.1,17.1h-4.7V4.9h4.7V17.1z"
    />
          <polygon points="32.5,41.7 38.7,41.7 36.6,52.8 45.7,38.5 40.5,38.5 42.7,27.5 "/>
          <polygon points="68.5,81.1 74.7,81.1 72.6,92.2 81.8,77.9 76.5,77.9 78.8,66.9 "/>
    </svg>
  );
};
